export function isBlank(value) {
  return (value == null) ||
    value === '' ||
    value === {} ||
    value === [];
}

export default {
  isBlank,
};
